import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { BaseList } from '../../list/base-list/base-list.js';

/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role
 *
 * @param props BaseListboxProps
 * @returns FunctionComponent<BaseListboxProps>
 */ const BaseListbox = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { 'aria-labelledby': ariaLabelledBy, children, className, id, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseList, {
        ...otherProps,
        "aria-labelledby": ariaLabelledBy,
        className: classnames({
            'bf-listbox': true,
            [`${className}`]: !!className
        }),
        id: id,
        ref: ref,
        role: "listbox",
        tabIndex: -1
    }, children);
});

export { BaseListbox };
//# sourceMappingURL=base-listbox.js.map
